// @flow

import { getCountry, getPaymentType } from '@tectonics/prs/incoming-payment';
import { type IncomingPayment } from './types';

export function shouldHideAcceptTermsInternationalTransfer(
  incomingPayment: IncomingPayment
): boolean {
  const country = getCountry(incomingPayment);
  const paymentType = getPaymentType(incomingPayment);

  const shouldHideAcceptTerms = country !== 'ke' || !['creditcard', 'ewallet'].includes(paymentType);

  return shouldHideAcceptTerms;
}
